<template>
  <div class="content">
    <div class="title">关于我们</div>
    <p>
      心期壹是国内领先的在线心理测评平台，研发团队包括国内知名的心理测量学和人格心理学专家及数据分析师，至今已陆续推出100多个备受欢迎的专业测评，覆盖人格、职场、爱情、能力、价值观等多个领域。
    </p>
    <p>
      我们秉承初心，以专业、严谨的态度，努力用最详尽的数据和图表对测评的结果进行个性化的解析和展示，并在最后给予有针对性的指导和建议，帮助每个人更好的探索自我个性，发掘自身潜力，探索更好的自己。
    </p>
  </div>
  <div
    class="back fa fa-chevron-left"
    @click="$router.back()"
  >

  </div>
</template>

<script>

export default {
  name: "about",
};
</script>

<style lang="less" scoped>
.content {
  padding: @padding-base;
  color: @light-black;
  .title {
    padding-bottom: 20px;
    font-size: 24px;
    text-align: center;
  }
  p {
    font-size: @font-size-lg;
    padding-bottom: 20px;
    line-height: 30px;
  }
}
.back {
  position: fixed;
  bottom: 100px;
  right: 20px;
  color: #fff;
  font-size: @font-size-lg;
  background-color: @theme-color;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  line-height: 40px;
  text-align: center;
}
</style>